import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface Area {
  id: number;
  name: string;
  properties: number;
}

const areas: Area[] = [
  { id: 1, name: "Vancouver", properties: 150 },
  { id: 2, name: "Burnaby", properties: 95 },
  { id: 3, name: "Richmond", properties: 80 },
  { id: 4, name: "Surrey", properties: 70 },
  { id: 5, name: "Coquitlam", properties: 45 },
  { id: 6, name: "New Westminster", properties: 35 },
  { id: 7, name: "North Vancouver", properties: 40 },
  { id: 8, name: "West Vancouver", properties: 25 }
];

export default function ServiceAreas() {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
            Serving All of the <span className="text-primary">Lower Mainland</span>
          </h2>
          <p className="text-lg text-text-secondary leading-relaxed">
            With over a decade of experience in the Lower Mainland market, we understand the unique maintenance needs of commercial properties across the region. Our local expertise means faster response times and better service.
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {areas.map((area) => (
            <div
              key={area.id}
              className="flex items-center gap-3 p-4 bg-surface border border-border rounded-xl hover:border-primary/50 hover:shadow-md transition-all duration-300"
            >
              <div className="p-2 bg-primary/10 rounded-lg flex-shrink-0">
                <Icon name="MapPinIcon" size={20} variant="solid" className="text-primary" />
              </div>
              <span className="font-semibold text-text-primary">{area.name}</span>
            </div>
          ))}
        </div>
        
        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="flex flex-col items-center text-center p-6 bg-surface rounded-xl border border-border">
            <div className="p-3 bg-primary/10 rounded-lg mb-3">
              <Icon name="TruckIcon" size={28} variant="solid" className="text-primary" />
            </div>
            <p className="font-semibold text-text-primary mb-1">Fast Response Times</p>
            <p className="text-sm text-text-secondary">Average 2-hour response across the Lower Mainland</p>
          </div>
          
          <div className="flex flex-col items-center text-center p-6 bg-surface rounded-xl border border-border">
            <div className="p-3 bg-primary/10 rounded-lg mb-3">
              <Icon name="MapIcon" size={28} variant="solid" className="text-primary" />
            </div>
            <p className="font-semibold text-text-primary mb-1">Local Expertise</p>
            <p className="text-sm text-text-secondary">Deep knowledge of regional property needs</p>
          </div>
          
          <div className="flex flex-col items-center text-center p-6 bg-surface rounded-xl border border-border">
            <div className="p-3 bg-primary/10 rounded-lg mb-3">
              <Icon name="ClockIcon" size={28} variant="solid" className="text-primary" />
            </div>
            <p className="font-semibold text-text-primary mb-1">24/7 On-Call Availability</p>
            <p className="text-sm text-text-secondary">Always here when you need us</p>
          </div>
        </div>
        
        <div className="text-center mt-10">
          <Link
            href="/contact"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:shadow-md transition-all duration-300 font-semibold"
          >
            <Icon name="EnvelopeIcon" size={20} variant="solid" />
            <span>Contact Your Local Team</span>
          </Link>
        </div>
      </div>
    </section>
  );
}